// extracted by css-extract-rspack-plugin
export default {"container":"imageWithDefault-module__container___SKGfJ","image":"imageWithDefault-module__image___tPMiE"};